import { render, staticRenderFns } from "./PaymentsReports.vue?vue&type=template&id=3f3307aa&"
import script from "./PaymentsReports.vue?vue&type=script&lang=js&"
export * from "./PaymentsReports.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports